/**
 * Sales order line item. Subcollection: org/{orgId}/sales-order/{salesOrderId}/item
 * Resolve the repository with context { orgId, salesOrderId }.
 *
 * Owned child row (no lifecycle). Audit via {@link Auditable} / ChildCrudService.
 * Invariants (totals, ≥1 item) are enforced in salesOrderService.
 *
 * Product reference follows canonical {@link ProductRef}: `productId` + optional
 * **partial** `variantId` (identifying axes; size lives on `SalesOrderItemBreakdown`).
 */
export const SALES_ORDER_ITEM = 'SalesOrderItem';
//# sourceMappingURL=sales-order-item.js.map